import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { ToastProvider } from './Toast';
import { DataRefreshProvider } from '@/hooks/useDataRefresh';
import { QuickActionProvider, useQuickAction } from '@/hooks/useQuickAction';
import QuickActionModals from './QuickActionModals';

function LayoutInner() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { activeModal, closeModal } = useQuickAction();

  // On mobile: toggle drawer; on desktop: toggle collapse
  const handleToggle = () => {
    if (window.innerWidth < 1024) {
      setMobileOpen(!mobileOpen);
    } else {
      setCollapsed(!collapsed);
    }
  };

  // Close mobile sidebar on navigate (handled in Sidebar via onToggle)

  return (
    <div className="flex h-screen overflow-hidden bg-background-50">
      {/* Desktop Sidebar + Mobile Drawer - hidden on non-mobile when collapsed and no mobile open */}
      <div className={`no-print ${mobileOpen ? 'block' : 'hidden'} lg:block`}>
        <Sidebar
          collapsed={collapsed}
          mobileOpen={mobileOpen}
          onToggle={handleToggle}
          onMobileClose={() => setMobileOpen(false)}
        />
      </div>

      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        {/* Header (desktop + mobile) */}
        <div className="no-print">
          <Header collapsed={collapsed} onToggle={handleToggle} />
        </div>

        <main className="flex-1 overflow-y-auto p-3 md:p-4 lg:p-6">
          <Outlet />
        </main>
      </div>

      {/* Quick Action Modals (shared desktop + mobile) */}
      <div className="no-print">
        <QuickActionModals modalType={activeModal} onClose={closeModal} />
      </div>
    </div>
  );
}

export default function Layout() {
  return (
    <ToastProvider>
      <DataRefreshProvider>
        <QuickActionProvider>
          <LayoutInner />
        </QuickActionProvider>
      </DataRefreshProvider>
    </ToastProvider>
  );
}